import {EventEmitter, Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataserviceService {
  baseUrl = '192.168.1.72:1000';
  message = new EventEmitter<{value: number, loader: boolean}>();
  constructor(public httpClient: HttpClient) {
  }
  tradingNote(data: any) {
    return this.httpClient.post(
      this.baseUrl + 'get_data',
      data,
    );
  }
}
